import React from "react";
import "./BoardBadge.scss";

const BoardBadge = ({
  children,
  variant = "default",
  icon,
  className = "",
  title,
}) => {
  const classes = [
    "pb-badge",
    variant !== "default" ? `pb-badge--${variant}` : "",
    icon ? "pb-badge--icon" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <span className={classes} title={title}>
      {icon && <span className="pb-badge__icon" aria-hidden="true">{icon}</span>}
      {children}
    </span>
  );
};

export default BoardBadge;
